import { Accept } from "react-dropzone";

import { ContentType } from "@/types";

import { isContentType } from "./typeGuards";

export const isImageMimetype = (mimetype: string) =>
  mimetype.startsWith("image/");

export const isVideoMimetype = (mimetype: string) =>
  mimetype.startsWith("video/");

export const isSVGMimeType = (mimetype: string) =>
  mimetype.startsWith("image/svg");

export const isPhotoshopMimeType = (mimetype: string) =>
  mimetype === "image/vnd.adobe.photoshop";

export const is3DMimetype = (mimetype: string) => mimetype.startsWith("model/");

export const isAudioMimetype = (mimetype: string) =>
  mimetype.startsWith("audio/");

export const isArchiveMimetype = (mimetype: string) =>
  mimetype === "application/zip" ||
  mimetype === "application/x-tar" ||
  mimetype === "application/gzip" ||
  mimetype === "application/x-bzip2" ||
  mimetype === "application/x-xz";

export const getExtensionsFromMimeType = (mimeType: string): string[] => {
  switch (mimeType) {
    case "image/jpeg":
    case "image/jpg":
      return [".jpg", ".jpeg"];
    case "image/png":
      return [".png"];
    case "image/gif":
      return [".gif"];
    case "image/webp":
      return [".webp"];
    case "image/svg+xml":
      return [".svg"];
    case "video/mp4":
      return [".mp4"];
    default:
      throw new Error("No extensions found for this mime type");
  }
};

enum ContentTypeEnum {
  IMAGE_JPEG = "image/jpeg",
  IMAGE_PNG = "image/png",
  VIDEO_MP4 = "video/mp4",
  AUDIO_MP3 = "audio/mp3",
  MODEL_GLB = "model/glb",
}

export const getContentTypeFromExtension = (extension: string): ContentType => {
  switch (extension) {
    case ".jpg":
      return ContentTypeEnum.IMAGE_JPEG;
    case ".jpeg":
      return ContentTypeEnum.IMAGE_JPEG;
    case ".png":
      return ContentTypeEnum.IMAGE_PNG;
    case ".mp4":
      return ContentTypeEnum.VIDEO_MP4;
    case ".mp3":
      return ContentTypeEnum.AUDIO_MP3;
    case ".glb":
      return ContentTypeEnum.MODEL_GLB;
    default:
      throw new Error("No content type found for this extension");
  }
};

export const getContentTypeFromAccept = (accept: Accept): ContentType[] => {
  return Object.keys(accept).filter(isContentType);
};
